export const handSanitizerSpecifications = [
    {
        heading: "Features",
        features: [
            "Eliminate bacteria",
            "Convenient and portable",
            "Minimum 60% alcohol for effectiveness",
            "Accessibility",
            "Meets FDA requirements"
        ]
    }
]; 